import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import TemplateService from "../../services/TemplateService";

const TemplateListing = ({ onCreateNew }) => {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      const response = await TemplateService.fetchTemplates();
      let data = [];

      if (response.data?.success && Array.isArray(response.data.data)) {
        data = response.data.data.map((template) => ({
          name: template.name,
          templateBody: template.templateBody,
          templateDetails: template.templateDetails,
          templateCategory: template.templateCategory,
          id: template.id,
          active: true, // default ON
        }));
      } else {
        console.error("API did not return expected data format");
      }

      setTemplates(data);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  const toggleSwitch = (id) => {
    setTemplates((prev) =>
      prev.map((tpl) =>
        tpl.id === id ? { ...tpl, active: !tpl.active } : tpl
      )
    );
  };

  return (
    <div className="p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Templates</h2>
        <Button variant="primary" onClick={onCreateNew}>
          Create New Template
        </Button>
      </div>

      <table className="table table-bordered">
        <thead className="table-light">
          <tr>
            <th>Name</th>
            <th>Category</th>
            <th>Active</th>
          </tr>
        </thead>
        <tbody>
          {templates.map((tpl) => (
            <tr key={tpl.id}>
              <td>{tpl.name}</td>
              <td>{tpl.templateCategory}</td>
              <td className="text-center">
                <Form.Check
                  type="switch"
                  id={`switch-${tpl.id}`}
                  checked={tpl.active}
                  onChange={() => toggleSwitch(tpl.id)}
                  label=""
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TemplateListing;
